var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 283,
    height: 15,
    viewBox: "0 0 283 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5317 5.36808C101.963 -0.772512 187.575 -0.522261 270.678 5.2796C286.508 6.38471 239.05 8.45556 223.204 8.91056C196.882 9.66633 170.547 9.188 144.22 8.91056C141.496 8.88185 138.799 8.07413 136.075 7.99238C113.619 7.31845 91.1534 7.40647 68.6997 6.64406C56.1105 6.21659 43.545 4.85846 30.9559 4.42309C22.133 4.11797 13.3033 4.23298 4.47863 4.42309C3.31595 4.44814 -0.139897 5.05136 1.02287 5.06795C32.3139 5.51428 63.6187 4.5684 94.9 5.71284C108.18 6.19872 121.364 9.0422 134.632 9.95611C185.721 13.4751 232.296 15.5592 282.54 10.0144",
    stroke: "#2350F1",
    strokeWidth: 1.57316
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath4);
export default __webpack_public_path__ + "static/media/path-4.6b9a99b53990681df46bd779a10b9473.svg";
export { ForwardRef as ReactComponent };